import { useState } from 'react';
import { DownOutlined, InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Typography } from 'antd';


const { Text } = Typography;


const MismatchGuideAccordion = ({ title = 'Mismatch Guide', children, marginBottom = 15, marginTop = 0 }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      style={{
        display: 'inline-block',
        width: 'fit-content',
        maxWidth: '100%',
        marginBottom,
		marginTop,
        transition: 'width 240ms ease',
      }}
    >
      <div
        onClick={() => setIsOpen((current) => !current)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 8px',
          border: '1px solid #91caff',
          borderRadius: 999,
          background: '#e6f4ff',
          cursor: 'pointer',
          width: 'fit-content',
          userSelect: 'none',
          transition: 'all 240ms ease',
          boxShadow: isOpen ? '0 6px 14px rgba(59, 130, 246, 0.12)' : 'none',
        }}
      >
        <InfoCircleOutlined style={{ color: '#1677ff' }} />
        <Text strong style={{ margin: 0, color: '#0958d9' }}>
          {title}
        </Text>
        {isOpen ? <DownOutlined style={{ color: '#1677ff' }} /> : <RightOutlined style={{ color: '#1677ff' }} />}
      </div>

      <div
        style={{
          maxHeight: isOpen ? 220 : 0,
          opacity: isOpen ? 1 : 0,
          overflow: 'hidden',
          marginTop: isOpen ? 10 : 0,
          padding: isOpen ? '12px 14px' : '0 14px',
          border: isOpen ? '1px solid #bae0ff' : '1px solid transparent',
          borderRadius: 16,
          background: '#f0f9ff',
          color: '#1e3a8a',
          transition: 'max-height 260ms ease, opacity 220ms ease, margin 220ms ease, padding 220ms ease',
		  fontFamily: 'sans-serif',
		  fontSize: "16px"
        }}
      >
        {children}
      </div>
    </div>
  );
};


export default MismatchGuideAccordion;
